import type { CreateCustomerInput } from '@chukua/common';
import { useState } from 'react';
import { ApiError } from '../../lib/api';
import { useToast } from '../../lib/use-toast';
import { createCustomer } from './customers.api';
import { useCustomerList } from './use-customer-list';

/** The customers list (`useCustomerList`) plus create — a form failure stays inline (CLAUDE.md → Web conventions). */
export function useCustomers() {
  const { state, list, isRefreshing, reload } = useCustomerList();
  const [createError, setCreateError] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);
  const toast = useToast();

  /** Returns whether it succeeded, so the drawer knows to close itself — same shape as useUsers.create. */
  async function create(input: CreateCustomerInput): Promise<boolean> {
    setCreateError(null);
    setCreating(true);
    try {
      await createCustomer(input);
      await reload();
      toast.success(`${input.name} created`);
      return true;
    } catch (err) {
      setCreateError(
        err instanceof ApiError && err.status === 409
          ? 'A customer with this KRA PIN already exists.'
          : 'Could not create the customer — check the fields and try again.',
      );
      return false;
    } finally {
      setCreating(false);
    }
  }

  return { state, list, isRefreshing, createError, creating, create, resetCreateError: () => setCreateError(null) };
}
